module.exports = __webpack_public_path__ + "a07531936e32375cd80614a523b2a2bb.png";